import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getFindUserContextPreferencesKey } from './userContextPreferences.keys';
import { findUserContextPreferences } from './userContextPreferences.repository';
import { UserContextPreferences } from './userContextPreferences.types';

export const useFindUserContextPreferences = (options?: UseDataQueryOptions) =>
  useDataQuery<UserContextPreferences | null>(
    {
      staleTime: Infinity,
      queryKey: getFindUserContextPreferencesKey(),
      queryFn: async () => {
        const data = await findUserContextPreferences();

        if (!data.ok) {
          throw data.originalError;
        }

        return data.data || null;
      },
    },
    options,
  );
